import React from "react";
import classes from "./Filters.module.css";
import images from "../../assets/images";
const Filters = ({
  filterHeaderIcon,
  filterHeader = "Filters",
  filterContent,
  filterFooter,
}) => {
  const { filter } = images;
  return (
    <div className={classes["filters"]}>
      <div className={classes["filters-header"]}>
        <div className={classes["filters-header-icon"]}>
          <img
            src={filterHeaderIcon || filter}
            alt="filter"
            width={20}
            height={20}
          />
        </div>
        <div className={classes["filters-header-title"]}>{filterHeader}</div>
      </div>
      <div className={classes["filters-content"]}>{filterContent}</div>
      <div className={classes["filters-footer"]}>{filterFooter}</div>
    </div>
  );
};

export default Filters;
